import React, { useState } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
const testimonials = [{
  initials: 'VM',
  name: 'Valentina M.',
  location: 'Buenos Aires',
  product: 'Mega Pack Cetosis Extrema',
  quote: 'Bajé 4 kilos en la primera semana. Las recetas son con ingredientes del almacén, no inventos importados. El Tomo 2 de desayunos es el que más uso.'
}, {
  initials: 'MR',
  name: 'Marcelo R.',
  location: 'Córdoba',
  product: 'Mega Pack + Keto Máster Pro',
  quote: '21 días, 7 kilos menos. Comí asado todos los domingos. El protocolo del día 4 me salvó porque justo ese día quería abandonar y el sistema me avisó que era normal.'
}, {
  initials: 'DP',
  name: 'Daniela P.',
  location: 'Rosario',
  product: 'Mega Pack Cetosis Extrema',
  quote: 'Probé keto antes con recetas de YouTube y siempre abandonaba. Esto es completamente distinto porque está pensado para Argentina, para el súper de barrio y para la vida real.'
}, {
  initials: 'FL',
  name: 'Fernando L.',
  location: 'Mendoza',
  product: 'Mega Pack + Keto Máster Pro',
  quote: 'El Tomo 4 de carnes es el mejor. Bifes, asado, milanesas keto. Todo lo que un argentino come de verdad. Sin trucos raros.'
}];
const faqs = [{
  q: '¿Sirve si nunca hice keto antes?',
  a: 'Sí. El Tomo 1 está diseñado específicamente para principiantes absolutos. Explica qué es la cetosis, cómo entrar en ella y qué esperar cada día de los 21.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital en formato PDF. Lo recibís en tu email en menos de 5 minutos después del pago. Lo podés leer en el celular, tablet o computadora.'
}, {
  q: '¿Los ingredientes se consiguen en Argentina?',
  a: 'Absolutamente. Todo el sistema está diseñado con ingredientes de supermercado, almacén y carnicería argentina. Sin harina de almendras, sin importados, sin productos de dietética cara.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía sin preguntas. Si no quedás satisfecho, te devolvemos el 100% del dinero. Sin formularios, sin demoras.'
}];
const costComparison = [{
  sin: 'Keto con recetas gringas que no aplican',
  costo: 'Abandono garantizado en la semana 1'
}, {
  sin: 'Ingredientes importados que no conseguís',
  costo: 'Plata tirada y frustración'
}, {
  sin: 'Sin protocolo para el día 4',
  costo: 'El 80% abandona ese día'
}, {
  sin: 'Sin recetas argentinas reales',
  costo: 'El asado del domingo rompe todo'
}, {
  sin: 'Sin sistema anti-antojos',
  costo: 'El pan y el dulce vuelven siempre'
}, {
  sin: 'El próximo lunes, de cero otra vez',
  costo: 'El mismo ciclo el próximo año'
}];
function FaqItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="bg-white border border-green-100 rounded-2xl overflow-hidden shadow-sm" data-id="element-184">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-5 md:p-6 text-left font-bold text-base md:text-lg text-green-900 hover:text-green-600 transition-colors" data-id="element-185">
        <span data-id="element-186">{q}</span>
        <svg className={`w-5 h-5 text-slate-500 shrink-0 ml-4 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-187">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-188" />
        </svg>
      </button>
      {open && <div className="px-5 md:px-6 pb-5 md:pb-6 text-slate-600 leading-relaxed text-sm md:text-base border-t border-green-100" data-id="element-189">
          <div className="pt-4" data-id="element-190">{a}</div>
        </div>}
    </div>;
}
export function TrustSection() {
  return <section className="py-16 md:py-24 bg-white/70 backdrop-blur-md border-t border-green-100" data-id="element-191">
      <div className="max-w-6xl mx-auto px-4" data-id="element-192">
        {/* Testimonials */}
        <h2 className="text-2xl md:text-4xl font-bold text-green-900 text-center mb-10 md:mb-16" data-id="element-193">
          ❤️ MÁS PERSONAS QUE YA LO TIENEN
        </h2>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto mb-20 md:mb-28" data-id="element-194">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-green-100 rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-195">
              <div className="flex items-center gap-3 md:gap-4 mb-5" data-id="element-196">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-green-50 text-green-600 flex items-center justify-center font-bold text-base md:text-xl border border-green-200" data-id="element-197">
                  {t.initials}
                </div>
                <div data-id="element-198">
                  <div className="text-green-600 text-xs tracking-wider mb-0.5" data-id="element-199">
                    ★★★★★
                  </div>
                  <div className="text-green-900 font-bold text-sm md:text-base" data-id="element-200">
                    {t.name}{' '}
                    <span className="text-slate-500 font-normal text-xs md:text-sm ml-1" data-id="element-201">
                      📍 {t.location}
                    </span>
                  </div>
                  <div className="text-xs text-green-600 font-medium mt-0.5" data-id="element-202">
                    | {t.product}
                  </div>
                </div>
              </div>
              <p className="text-slate-700 italic text-sm md:text-lg leading-relaxed" data-id="element-203">
                "{t.quote}"
              </p>
            </div>)}
        </div>

        {/* Guarantee */}
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-white to-green-50 border border-green-200 rounded-2xl md:rounded-3xl p-8 md:p-14 text-center mb-20 md:mb-28 relative overflow-hidden shadow-md" data-id="element-204">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-green-600" data-id="element-205" />
          <div className="text-6xl md:text-7xl mb-6" data-id="element-206">🛡️</div>
          <h2 className="text-2xl md:text-4xl font-bold text-green-900 mb-5" data-id="element-207">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="text-base md:text-xl text-slate-700 mb-6 leading-relaxed" data-id="element-208">
            Abrís los tomos. Usás las recetas. Seguís el protocolo.
            <br data-id="element-209" />
            Si en 7 días no es lo que esperabas:
            <br data-id="element-210" />
            <strong className="text-green-900" data-id="element-211">devolución del 100%</strong>
            <br data-id="element-212" />
            sin formularios, sin drama.
          </p>
          <div className="inline-block bg-white px-5 py-2.5 rounded-full text-green-600 font-medium border border-green-200 text-sm" data-id="element-213">
            Tasa de devoluciones: menos del 1%.
          </div>
        </div>

        {/* FAQ */}
        <div className="max-w-3xl mx-auto mb-20 md:mb-28" data-id="element-214">
          <h2 className="text-2xl md:text-4xl font-bold text-green-900 text-center mb-10 md:mb-12" data-id="element-215">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="space-y-3 md:space-y-4" data-id="element-216">
            {faqs.map((faq, i) => <FaqItem key={i} q={faq.q} a={faq.a} data-id="element-217" />)}
          </div>
        </div>

        {/* Cost Comparison */}
        <div className="max-w-4xl mx-auto mb-20 md:mb-28" data-id="element-218">
          <h2 className="text-2xl md:text-4xl font-bold text-green-900 text-center mb-10 md:mb-12" data-id="element-219">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
          <div className="bg-white border border-green-100 rounded-2xl md:rounded-3xl overflow-hidden shadow-md" data-id="element-220">
            <div className="overflow-x-auto" data-id="element-221">
              <table className="w-full text-left min-w-[500px]" data-id="element-222">
                <thead data-id="element-223">
                  <tr className="bg-green-50" data-id="element-224">
                    <th className="p-4 md:p-6 text-slate-700 font-semibold text-sm border-b border-green-200 w-1/2" data-id="element-225">
                      Sin Mega Pack
                    </th>
                    <th className="p-4 md:p-6 text-red-600 font-semibold text-sm border-b border-green-200 w-1/2" data-id="element-226">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-227">
                  {costComparison.map((row, i) => <tr key={i} className="border-b border-green-100 hover:bg-green-50/50 transition-colors" data-id="element-228">
                      <td className="p-4 md:p-6 text-green-900 font-medium text-sm" data-id="element-229">
                        {row.sin}
                      </td>
                      <td className="p-4 md:p-6 text-slate-600 text-sm" data-id="element-230">
                        {row.costo}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="max-w-4xl mx-auto text-center bg-white border border-green-200 rounded-2xl md:rounded-3xl p-6 md:p-14 relative overflow-hidden shadow-lg" data-id="element-231">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-xl h-[250px] rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(34,197,94,0.1) 0%, transparent 70%)'
        }} data-id="element-232" />

          <h2 className="text-3xl md:text-5xl font-bold text-green-900 mb-6 relative z-10" data-id="element-233">
            El próximo lunes puede ser diferente.
          </h2>

          <div className="mb-10 relative z-10" data-id="element-234">
            <div className="text-red-600 font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-235">
              ⏰ EL PRECIO CIERRA EN:
            </div>
            <CountdownTimer data-id="element-236" />
          </div>

          <div className="flex flex-col md:flex-row gap-4 md:gap-6 justify-center relative z-10 mb-10" data-id="element-237">
            <a href="#pricing" className="flex-1 bg-green-100 hover:bg-green-200 text-green-900 font-bold py-5 px-6 rounded-2xl transition-colors border border-green-200 flex flex-col items-center justify-center gap-1" data-id="element-238">
              <span className="text-lg md:text-xl" data-id="element-239">MEGA PACK</span>
              <span className="text-green-600 font-bold" data-id="element-240">$19.990 ARS</span>
              <span className="text-xs font-normal text-slate-600 mt-1" data-id="element-241">
                → QUIERO MI MEGA PACK
              </span>
            </a>
            <a href="#pricing" className="animate-pulse-glow flex-1 bg-green-600 hover:bg-green-500 text-white font-bold py-5 px-6 rounded-2xl transition-all active:scale-95 flex flex-col items-center justify-center gap-1 shadow-lg" data-id="element-242">
              <span className="text-lg md:text-xl" data-id="element-243">
                MEGA PACK + KETO MÁSTER PRO ⭐
              </span>
              <span className="text-white font-bold" data-id="element-244">$27.990 ARS</span>
              <span className="text-xs font-bold text-green-100 mt-1" data-id="element-245">
                → QUIERO EL MEGA PACK + KETO MÁSTER PRO
              </span>
            </a>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-xs md:text-sm font-medium text-slate-600 relative z-10" data-id="element-246">
            <span data-id="element-247">🔒 Pago 100% seguro</span>
            <span data-id="element-248">⚡ Acceso en 5 minutos</span>
            <span data-id="element-249">🛡️ Garantía 7 días</span>
            <span data-id="element-250">💳 Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}